export default {
  props: {
    mdTheme: String,
  },
  data: () => ({
    closestThemedParent: false,
  }),
  methods: {
    getClosestThemedParent($parent) {
      if (!$parent || !$parent.$el || $parent._uid === 0) { // eslint-disable-line
        return false;
      }

      if ($parent.mdTheme || $parent.mdName) {
        return $parent;
      }

      return this.getClosestThemedParent($parent.$parent);
    },
  },
  computed: {
    themeClass() {
      if (this.mdTheme) {
        return `md-theme-${this.mdTheme}`;
      }

      let theme = this.closestThemedParent.mdTheme;

      if (!theme) {
        theme = (this.closestThemedParent) ?
          this.closestThemedParent.mdName :
          this.$material.currentTheme;
      }

      return `md-theme-${theme}`;
    },
  },
  mounted() {
    this.closestThemedParent = this.getClosestThemedParent(this.$parent);

    if (!this.$material.currentTheme) {
      this.$material.setCurrentTheme('default');
    }
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/chipsautocomplete/mdTheme.js